import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShowtimesModalComponent } from './showtimes-modal.component';
import { DatePickerWrapperModule } from '@finder/shared/components/date-picker-wrapper/date-picker-wrapper.module';
import { InputModule } from '@finder/shared/components/input/input.module';
import { LoadingSpinnerModule } from '@finder/shared/components/loading-spinner/loading-spinner.module';
import { ScheduleListModule } from '@finder/shared/components/schedule-list/schedule-list.module';

@NgModule({
    imports: [
        CommonModule,
        DatePickerWrapperModule,
        InputModule,
        LoadingSpinnerModule,
        ScheduleListModule,
    ],
    declarations: [
        ShowtimesModalComponent,
    ],
    providers: [],
    exports: [
        ShowtimesModalComponent
    ]
})
export class ShowtimesModalModule {
    static entry = ShowtimesModalComponent;
}
